<template>
  <nav
    class="app-navbar"
  >
    <!-- <div class="brand-logo">
      <router-link to="/">
        <b-img
          :src="require('@/assets/images/logo/logo.png')"
          fluid
          alt="logo"
        />
      </router-link>
    </div> -->
    <button
      ref="menubtn"
      class="menu-btn"
      @click="openMenu($event)"
    >
      <p class="">
        MENU
      </p>
      <div class="underline" />
      <div class="underline" />
    </button>
    <div
      ref="menu"
      class="menu"
    >
      <div class="homeimg-link">
        <router-link to="/">
          <b-img
            :src="require('@/assets/images/logo/logo.png')"
            fluid
            alt="logo"
          />
        </router-link>
      </div>
      <div class="menu-tabs">
        <div class="menu-tab">
          <a href="#about">
            關於我們
          </a>
        </div>
        <div class="menu-tab">
          <a href="#service">
            服務項目
          </a>
        </div>
        <div class="menu-tab">
          <a href="#feature">
            特色優勢
          </a>
        </div>
        <div class="menu-tab">
          <a href="#contact">
            聯絡我們
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {
  BImg,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BImg,

    // Navbar Components
    // DarkToggler,
  },
  props: {},
  methods: {
    openMenu() {
      this.$refs.menu.classList.toggle('active')
      this.$refs.menubtn.classList.toggle('active')
    },
  },

  setup() {
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/font/font.css';
.app-navbar {
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
}
.brand-logo {
  position: relative;
  left: 0;
  padding: 1rem;
  height: 100%;
  img {
    height: 100%;
  }
}
.menu-btn {
  position: fixed;
  z-index: 20;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  background-color: #ffffff;
  border: none;
  p {
    display: block;
    width: 100%;
    margin: 0;
    font-weight: 900;
    transition: .4s;
  }
  .underline {
    height: 3px;
    width: 40px;
    margin: 4px 0;
    background-color: #000000;
    border-radius: 40px;
    transition: .4s;
  }
}
.menu-btn.active{
  p {
    opacity: 0;
  }
  :nth-child(2) {
    transform: rotate(-45deg) translateY(0px) translateX(0px)
  }
  :nth-child(3) {
    transform: rotate(45deg) translateY(-7px) translateX(-7px)
  }
}
.menu {
  position: fixed;
  display: none;
  z-index: 10;
  top: 0;
  right: 0;
  margin: 0px;
  padding: 110px 58px 110px 46px;
  height: 100%;
  width: 340px;
  max-width: 100%;
  background-color: #000000;// #262641 #151523 #030306
  &.active {
    display: block;
  }
}
.homeimg-link {
  margin-bottom: 3rem;
}
.menu-tabs {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #232323;

  .menu-tab {
    padding: 20px 0;
    transition: transform 0.3s;
    border-bottom: 1px solid #232323;
    a {
      display: inline-block;
      font-family: 'Cubic';
      font-size: 20px;
      font-weight: 600;
      color:#fff;
    }
    &:hover {
      a{
        transform: scale(1.2);
      }
    }
  }
}
</style>
